import { render, staticRenderFns } from "./AlliedPartyAgenda.vue?vue&type=template&id=399d31f3"
import script from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"
export * from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports